import React from "react";

import IconTable from "../../assets/icons/icon-table-black1.svg";
import IconCardsGray from "../../assets/icons/icon-cards-gray1.svg";

import * as S from "./styles";

// Segmented control com os dois modos de visualização lado a lado
// (tabela/cards), substituindo o antigo ButtonSwitchImage - que só
// mostrava um ícone (o do modo oposto) e alternava ao clicar.
const SwitchLayout = ({ isTableView, onClick, disabled = false }) => {
  const handleSelect = (view) => {
    if (disabled) return;
    const isAlreadySelected = (view === "table") === isTableView;
    if (isAlreadySelected) return;
    onClick();
  };

  return (
    <S.Container disabled={disabled}>
      <S.Option
        type="button"
        active={isTableView}
        disabled={disabled}
        aria-label="Ver em tabela"
        aria-pressed={isTableView}
        onClick={() => handleSelect("table")}
      >
        <img src={IconTable} alt="" />
      </S.Option>

      <S.Option
        type="button"
        active={!isTableView}
        disabled={disabled}
        aria-label="Ver em cards"
        aria-pressed={!isTableView}
        onClick={() => handleSelect("cards")}
      >
        <img src={IconCardsGray} alt="" />
      </S.Option>
    </S.Container>
  );
};

export default SwitchLayout;
